import styled from "styled-components";

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

export default Image;
